import { FC, useEffect } from "react";
import useUserInfo from "../../../../hooks/user-info";
import UserInfoTooltip from "../user-info-click-tooltip";

const UserInfoTooltipHook: FC<{ userEmail: string }> = ({ userEmail }) => {
  const [user, setUser] = useUserInfo();

  useEffect(() => {
    setUser(userEmail);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userEmail]);

  return (
    <UserInfoTooltip user={user} />
  );
};

export default UserInfoTooltipHook;
